import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar";
import { Fundcode, IProjectDetail, ISelectOption } from "../../utils/types";
import { getStoredUserData, getUserSession, makeYears } from "../../utils/utils";
import { ApiClient } from "../../utils/apiclient";
import { ChangeEvent, useEffect, useState } from "react";
import Spinner from "../../components/spinner";
import TopStrip from "../../components/top_strip";
import { getCityNames } from 'postcodes-tz'
import { Formik } from "formik";
import * as Yup from 'yup'
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import { set } from "react-datepicker/dist/date_utils";

const VehicleForm = (props: any) => {
    const session = getUserSession()
    const apiClient = new ApiClient(session?.accessToken);
    const userData = getStoredUserData();
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [projects, setProjects] = useState<IProjectDetail[]>([])
    const [fundcodes, setFundcodes] = useState<Fundcode[]>([]);
    const [fFundcodes, setFFundcodes] = useState<Fundcode[]>([])
    const [selectedProject, setSelectedProject] = useState<ISelectOption | null>(null)
    const [selectedYear, setSelectedYear] = useState<ISelectOption | null>(null)
    const [selectedFundcode, setSelectedFundcode] = useState<ISelectOption | null>(null)


    const formValidationSchema = Yup.object({
        pnumber: Yup.string().required('Registration number required'),
        brand: Yup.string().required('Provide vehicle manufacturer'),
        model: Yup.string().required('Please enter the vehicle model'),
        // year: Yup.number().required('Year of manufacturing'),
        // project: Yup.string().required('Please select a project'),
        // fundcode: Yup.string().required('Please provide a fundcode'),
        location: Yup.string().required("Please select a location"),
        chassis_no: Yup.string().required("Please enter chassis number or VIN"),
        a_date: Yup.date().required()
    })
    const handleCancel = () => {
        navigate(-1)
    }
    const showNotifications = () => {
        navigate(`/notifications/${userData?.id}`)
    }
    const getProjects = async () => {
        const axios = await apiClient.getActiveProjects();
        if (axios.data) {
            setProjects(axios.data.projects)
        }
    }
    const getFundcodes = async () => {
        const axios = await apiClient.getActiveFundcodes();
        if (axios.data) {
            setFundcodes(axios.data.fundcodes)
            setFFundcodes(axios.data.fundcodes)
        }
    }

    const handleProjectChange = (e: any) => {
        const pj =projects.find((p:IProjectDetail) => p.id == e.value)
        setSelectedProject({value: pj?.id || null,label: pj?.code || ''})
        setFFundcodes(fundcodes.filter((f: Fundcode) => f.project_id == e.value))
    }

    const formHandler = async (values: any) => {
        console.log("🚀 ~ formHandler ~ values:", values)
        setIsLoading(true);
        values.a_date = Date.parse(values.a_date) / 1000;
        values.project_id = selectedProject?.value;
        values.project = selectedProject?.label;
        values.fundcode = selectedFundcode?.value;
        values.year = selectedYear?.value;
        console.log("🚀 ~ formHandler ~ values:", values)
        if(!selectedFundcode) {
            toast.error("Please select a fund code");
            setIsLoading(false);
            return;
        }
        if(!selectedProject) {
            toast.error("Please select a project");
            setIsLoading(false);
            return;
        }
        if(!selectedYear) {
            toast.error("Please select a year");
            setIsLoading(false);
            return;
        }
        const axios = await apiClient.createVehicle(values);
        console.log("🚀 ~ formHandler ~ axios:", axios)
        toast.info(axios.data, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        })
        setIsLoading(false)
        setTimeout(() => {
            navigate('/vehicles')
        }, 2000)
    }
    const handleYearChange = (selectedOption: ISelectOption) => {
        setSelectedYear(selectedOption);
    }
    const handleFCodeChange = (selectedOption: ISelectOption) => {
        setSelectedFundcode(selectedOption)
    }
    useEffect(() => {
        getProjects();
        getFundcodes()
    }, [])
    return (<>
        <div className="w-full flex justify-end items-center bg-gray-100 pe-4">
            <TopStrip user={userData} />
        </div>
        <main className="w-full flex bg-white min-h-full">
            <div className="md:w-2/12 flex flex-col items-start text-center justify-center">
                <Sidebar notificationCount={[].length} user={userData} active={3} />                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 f
            </div>
            <ToastContainer />
            <div className="md:w-9/12 mx-auto space-y-4 mt-2">

                <div className="w-full">
                    <div className="w-full flex items-center justify-between p2-4">
                        <p className="text-2xl font-bold">Add New Vehicle</p>
                    </div>
                    {isLoading ? <Spinner className="spinner-md mt-6" /> :
                        <div className="w-full flex justify-between items-start py-6 mx-auto border mt-6 h-full">

                            <Formik validationSchema={formValidationSchema} initialValues={{ a_cost:"", a_date: "", chassis_no: "", pnumber: "", brand: "", model: "", year: "", mileage: 0, current_mileage: 0, project: "", location: userData?.location, fundcode: "" }} onSubmit={formHandler}>
                                {({ handleSubmit, handleChange, values, errors, touched }) => (
                                    <form
                                        name="new-user-form"
                                        id="new-user-form" className="mt-4 mx-auto"
                                        onSubmit={handleSubmit}
                                    >
                                        <div className="w-full py-6 mx-auto">
                                            <p>{JSON.stringify(errors)}</p>
                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Registration</label>
                                                    <input type="text" className="form-control" name="pnumber" id="pnumber" onChange={handleChange} placeholder="T335DPA" />
                                                    {errors && errors.pnumber ? <small className="text-sm text-red-500">{errors.pnumber}</small> : null}
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Chassis Number</label>
                                                    <input type="text" className="form-control" id="chassis_no" name="chassis_no" placeholder="Enter chassis number" onChange={handleChange} />
                                                    {errors && errors.chassis_no ? <span className="text-sm text-red-500">{errors.chassis_no}</span> : null}
                                                </div>
                                            </div>

                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Make</label>
                                                    <input type="text" className="form-control" name="brand" id="brand" onChange={handleChange} placeholder="Toyota" />
                                                    {errors && errors.brand ? <span className="text-sm text-red-500">{errors.brand}</span> : null}
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Model</label>
                                                    <input type="text" className="form-control" id="model" name="model" placeholder="Landcruiser" onChange={handleChange} />
                                                    {errors && errors.model ? <span className="text-sm text-red-500">{errors.model}</span> : null}
                                                </div>
                                            </div>
                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Year of Manufacture</label>
                                                    <Select id="year" name="year" onChange={(e: any) => { handleYearChange(e) }} options={makeYears(30).map((y: number) => ({ value: y, label: `${y}` }))} />
                                                    {selectedYear === null ? <span className="text-sm text-red-500">{errors.year}</span> : null}
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Initial Cost (Tsh)</label>
                                                    <input type="number" className="form-control" id="a_cost" name="a_cost" placeholder="Enter cost" onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Current Mileage (Km)</label>
                                                    <input type="number" className="form-control" id="current_mileage" name="current_mileage" defaultValue={0} placeholder="Vehicle Mileage" onChange={handleChange} />
                                                    {errors && errors.current_mileage ? <span className="text-sm text-red-500">{errors.current_mileage}</span> : null}
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Initial Mileage (Km)</label>
                                                    <input type="number" className="form-control" id="mileage" name="mileage" placeholder="Enter initial mileage" onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Donor</label>
                                                    <input type="text" className="form-control" id="donor" name="donor" placeholder="Enter donor" onChange={handleChange} />
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Current Location</label>
                                                    <select
                                                        className="form-control "
                                                        defaultValue={userData?.location.trim()}
                                                        name="location"
                                                        id="location"
                                                        onChange={handleChange}
                                                    >
                                                        {getCityNames("asc").map((c: string) => {
                                                            return <option key={c}>{c}</option>;
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label>Select Project</label>
                                                    <Select
                                                        required
                                                        id="project"
                                                        name="project" onChange={(e) => {
                                                            handleProjectChange(e);
                                                        }} options={projects.map((p: IProjectDetail) => ({ value: p.id, label: p.code }))} />


                                                    {!selectedProject ? <span className="text-sm text-red-500">{errors.project}</span> : null}
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Fund Code</label>
                                                    <Select
                                                        id="fundcode"
                                                        name="fundcode"
                                                        onChange={(e: any) => { handleFCodeChange(e) }} options={fFundcodes.map((p: Fundcode) => ({ value: p.code, label: p.code }))} />
                                                </div>
                                            </div>
                                            <div className="space-x-4 flex justify-between items-start">
                                                <div className="text-start mb-4 w-6/12">
                                                    <label className="text-gray-500">Date Acquired</label>
                                                    <input type="date" className="form-control" name="a_date" id="a_date" onChange={handleChange} />
                                                    {errors && errors.a_date ? <small className="text-sm text-red-500">{errors.a_date}</small> : null}
                                                </div>
                                                <div className="text-start mb-4 w-6/12">
                                                    {/* <label className="text-gray-500">Chassis Number</label>
                                                <input type="text" className="form-control" id="chassis_no" name="chassis_no" placeholder="Enter chassis number" onChange={handleChange}/>
                                                {errors && errors.chassis_no ? <span className="text-sm text-red-500">{errors.chassis_no}</span> : null} */}
                                                </div>
                                            </div>
                                            <div className="space-x-4 flex justify-between items-start">
                                                {isLoading ? <Spinner className="spinner-sm-white my-2" /> :
                                                    <button
                                                        className="text-white bg-accent"
                                                        type="submit"
                                                        id="submitUser"
                                                    >Save</button>}
                                                <button
                                                    id="cancel-user"
                                                    className="border border-accent text-accent"
                                                    onClick={handleCancel}
                                                >
                                                    CANCEL
                                                </button>
                                            </div>
                                        </div>
                                    </form>)}
                            </Formik>
                        </div>}

                </div>
            </div>
        </main>
    </>)
}
export default VehicleForm;